import { deleteExpert, getExpertList } from '../services/index';

export default {
  namespace: 'expertLibrary',
  state: {},
  effects: {
    // 获取列表接口
    *getExpertList({ payload }, { call }) {
      return yield call(getExpertList, payload);
    },
    // 删除专家
    *deleteExpert({ payload }, { call }) {
      return yield call(deleteExpert, payload?.expertId);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
